import React from 'react';

import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { hideProcess, showProcess } from '../utils/utils';
import UsuarioService from '../services/UsuarioService';

import CryptoJS from 'crypto-js';
import AutenticacaoService from '../services/AutenticacaoService';


class Entrar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            acesso: {},
            lemmbrar: false
        }
    }

    componentDidMount(){    
    
    }

    entrar = async (e) => {

        e.preventDefault();

        var password = CryptoJS.MD5(this.state.senha).toString()
 
        const credenciais = {
            login: this.state.usuario,
            password: password
        };

        showProcess();
        
        try{
            await AutenticacaoService.autenticar(credenciais).then(res => {
                if (res.data.token !== undefined){
                    localStorage.setItem("authorization", res.data.token);
                    localStorage.setItem("usuario", JSON.stringify(res.data));
                    window.location.href = "/loja";
                }else{
                    alert(res.data);
                }
            });
        }catch(e){
            alert("Credenciais inválidas.");
        }

        hideProcess();

    }

    confirmarUsuario = async(e) => {

        e.preventDefault();

        try{
            await showProcess();

            const response = await UsuarioService.getByUsuario(this.state.usuario);

            if (response.data.status = 'sucess'){

                
                if (response.data.object === null){
                    
                    alert("Usuário não encontrado.");

                    hideProcess();

                    return;

                }

                this.setState({acesso: {usuario: this.state.usuario}})

            }else{

                alert(response.data.message);

                hideProcess();

                return;

            }


        }catch(e){

            alert(e);

            hideProcess();

        }

        hideProcess();
        
    }

  

    render() {
        return(
            <>
            <div style={{height: '5%', width: '100%', backgroundColor: '#CB2821'}}>                    
            </div>
            <div className='app-entrar'>
                <div>
                    <div style={{textAlign: 'center', marginBottom: '20px'}}>
                        <img src={require("../img/logo-1.png")} style={{maxWidth: '120px'}} />
                    </div>

                    {this.state.acesso.usuario === undefined &&
                        <form onSubmit={(e) => this.confirmarUsuario(e)}>
                            <div style={{marginTop: '20px'}}>
                                <h1>Entrar</h1>
                            </div>

                            <div>
                                <InputText required placeholder='Entre com seu CPF ou CNPJ' style={{minWidth: '100%'}} value={this.state.usuario} onChange={(e) => this.setState({usuario: e.target.value})}/>
                            </div>
                            
                            <div style={{marginTop: '20px'}}>
                                Não tem uma conta? <a href="/pre-cadastro" style={{color: '#B0C4DE'}}>Crie uma!</a>
                            </div>

                            <div style={{marginTop: '20px'}}>
                                <a href="/pre-cadastro" style={{color: '#B0C4DE'}}>Não consegue acessar sua conta?</a>
                            </div>

                            <div>
                                <Button label="AVANÇAR" type='submit' className='app-background-gold' style={{float: 'right'}} />
                            </div>
                        </form>
                    }

                    {this.state.acesso.usuario !== undefined &&
                        <form onSubmit={(e) => this.entrar(e)}>
                            <div style={{marginTop: '20px'}}>
                                <h1>Informe sua senha</h1>
                            </div>
                            <div style={{marginTop: '20px'}}>
                                <Password placeholder='Senha' style={{width: '100%'}} inputStyle={{width: '100%'}} value={this.state.senha} onChange={(e) => this.setState({senha: e.target.value})} toggleMask feedback={false} tabIndex={1} />
                            </div>
                            
                            <div className="flex align-items-center" style={{marginTop: '20px'}}>
                                <Checkbox inputId="chk-lembrar" value={this.state.lembrar} onChange={(e) => {this.setState({lembrar: e.checked})}} checked={this.state.lembrar} />
                                <label htmlFor="chk-lembrar" className="ml-2">Lembrar</label>
                            </div>

                            <div>
                                <Button label="CONFIRMAR" className='app-background-gold' style={{float: 'right'}} />
                            </div>
                        </form>
                    }
                </div>
                    
            </div> 
            <div style={{height: '5%', width: '100%', backgroundColor: '#CB2821'}}>                    
            </div>           
            </>
        );
        
    }


}
export default Entrar;
